import { useSelect } from '@refinedev/antd';
import { useTranslate } from '@refinedev/core';
import { Select } from 'antd';
import type { SelectProps } from 'antd';
import type { CollectionOut } from '@/api/generated/schemas';

interface CollectionPickerProps extends Omit<
  SelectProps,
  'options' | 'children'
> {
  preselectedIds?: number[];
}

/**
 * Searchable collection select. Server-side `q` contains search; options are
 * labelled with the collection name plus its kind, which is the only way two
 * same-named collections tell themselves apart.
 */
export const CollectionPicker = ({
  preselectedIds,
  ...selectRest
}: CollectionPickerProps) => {
  const t = useTranslate();

  const { selectProps } = useSelect<CollectionOut>({
    resource: 'user_catalog.collections',
    // useSelect's key typing only admits `'id'` for untyped records; any
    // key path works at runtime.
    optionLabel: 'name_with_collection_kind' as 'id',
    optionValue: 'id',
    onSearch: (value) => [{ field: 'q', operator: 'contains', value }],
    defaultValue: preselectedIds?.length ? preselectedIds : undefined,
  });

  return (
    <Select
      {...selectProps}
      showSearch
      filterOption={false}
      placeholder={t('user_catalog.common.collections_editor.placeholder')}
      {...selectRest}
    />
  );
};
